// @flow

import type { NotificationName } from './state'

type ActionParams = {
  commit: any
}

export const actions = {
  toggleNotification ({ commit }: ActionParams, name: NotificationName): void {
    commit('toggle', name)
  }
}
